import { GATEWAY, buidlURL, fetchRequest, distance, calcPrice } from '@/api';
import Vue from 'vue';
import router from '@/router';
// import { join } from 'path';

const onPage = 10;

const state = {
  query: null,
  loading: false,
  error: false,
  errors: [],
  total_hotels: null,
  total_pages: null,
  next_page: false,
  hotels: [],
  maxPrice: 500000,
  region: null,
  // hotelsClean: [],
  hotelsFiltered: [],
  useFilter: false,
  filters: {
    hotelName: false,
    stars: false,
    max: true,
    min: true,
  },
  page: 0,
  hotelsWaitingInfo: [],
  wait: {
    hotels: 'Подождите, идет поиск отелей',
    relativeHotels: 'Подождите, идет поиск похожих отелей'
  },
  errorList: {
    getHotels: 'Не получилось загрузить отели: getHotels error',
    getHotelInfo:
      'Не получилось загрузить информцию об отеле: getHotelInfo error',
    getRelativeHotels: 'Не получилось загрузить отели: getRelativeHotels error'
  },
  map: null,
  hotelHoveredID: '',
  favoriteHotels: [],
  // isGettingHotelInfoStopped: false,
};
const initialState = Object.assign({}, state);
// const L = window.L;

const getters = {
  rooms: state => {
    const hotels = state.useFilter ? state.hotelsFiltered : state.hotels;
    if (hotels === 0) return [];
    return hotels
      .filter(
        (_, index) =>
          index >= state.page * onPage && index < (state.page + 1) * onPage
      )
      .filter(hotel => hotel.rates)
      .map(hotel => ({
        hotel,
        ...hotel.rates[0]
      }));
  },
  pageCount: state =>
    Math.ceil(
      (state.useFilter ? state.hotelsFiltered.length : state.hotels.length) /
        onPage
    ),
};

const actions = {
  getRelativeHotels({ state, commit }) {
    commit('setLoading', state.wait.relativeHotels, {
      root: true
    });
    // console.log(state.region);

    const query = { ...state.query };
    delete query.ids;
    const url = buidlURL(GATEWAY, {
      type: 'search',
      ...query,
      region_id: state.region.id
    });

    return fetchRequest(
      url,
      response => {
        if (response.error)
          return Promise.reject(
            commit('throwError', state.errorList.getRelativeHotels)
          );

        commit('updateRelativeHotels', response.result);
        commit('setLoading', state.wait.relativeHotels, {
          root: true
        });

        return Promise.resolve();
        // dispatch('getHotelInfoDB');
      },
      () => commit('throwError', state.errorList.getRelativeHotels)
    );
  },
  getHotels({ commit, dispatch, state }, query) {
    commit('updateHotels', { hotels: [] });
    commit('updateQuery', query);
    commit('setLoading', state.wait.hotels, { root: true });
    commit('cleanHotelsWaitingInfo');

    const url = buidlURL(GATEWAY, {
      type: 'search',
      ...query
    });

    return fetchRequest(
      url,
      response => {
        if (response.error)
          return Promise.reject(
            commit('throwError', state.errorList.getHotels)
          );

        commit('updateHotels', response.result);
        commit('setLoading', state.wait.hotels, {
          root: true
        });

        return Promise.all([
          dispatch('getRegionCoords'),
          dispatch('getHotelInfo'),
          dispatch('getHotelInfoDB'),
          /* .then(() => dispatch('getHotelsRating')) */
        ]);
      },
      () => {
        // console.log(error);
        commit('throwError', state.errorList.getHotels);
      }
    );
  },

  getRegionCoords({ state, commit, rootState }) {
    // console.log(state.query, rootState.hotel.hotel.info.region_id);
    const url = buidlURL(GATEWAY, {
      type: 'regioninfodb',
      id: state.query.region_id || rootState.hotel.hotel.info.region_id
    });
    return fetchRequest(url, response =>
      commit('updateRegion', response.result[0])
    );
  },

  // getHotelsRating({ commit }) {
  //   return console.warn('Do not forget ratings');

  //   // const body = new FormData();
  //   // body.append('type', 'hotelsratingdb');
  //   // body.append('ids', state.hotels.map(hotel => hotel.id).join(','));
  //   // const data = {
  //   //   method: 'POST',
  //   //   body
  //   // };
  //   // return fetchRequest({ url: GATEWAY, data }, response =>
  //   //   commit('updateHotelsRating', response.result)
  //   // );
  // },

  getHotelInfo({ commit, state }, id) {
    let ids = id
      ? [id]
      : state.hotels.filter((_, i) => i < 5).map(hotel => hotel.id);

    ids = ids.filter(id => !state.hotelsWaitingInfo.includes(id));
    if (ids.length === 0) return;

    commit('updateHotelsWaitingInfo', ids);

    const url = buidlURL(GATEWAY, {
      type: 'hotelinfo',
      ids
    });
    return fetchRequest(
      url,
      response => {
        if (response.error) {
          commit('removeHotelsWaitingInfo', ids);
          return Promise.reject(
            commit(
              'throwError',
              state.errorList.getHotelInfo + ' ' + ids.join(', ')
            )
          );
        }
        commit('updateHotelInfo', response.result);
        return Promise.resolve();
      },
      () => {
        commit('removeHotelsWaitingInfo', ids);
        commit(
          'throwError',
          state.errorList.getHotelInfo + ' ' + ids.join(', ')
        );
      }
    );
  },
  async getHotelInfoDB({ state, commit/* dispatch */ }) {
    const ids = state.hotels.map(hotel => hotel.id);
    const chunkIds = [];
    while (ids.length > 0) {
      chunkIds.push(ids.splice(0, 50));
    }

    async function getInfo(hotelIds) {
      const body = new FormData();
      body.append('type', 'hotelrowsdb');
      body.append('ids', hotelIds.join(','));
      const data = {
        method: 'POST',
        body
      };

      return fetchRequest({ url: GATEWAY, data }, response => {
        response.result.forEach(main_info => {
          const hotelFound = state.hotels.find(
            hotel => hotel.id === main_info.ostrovok_id
          );
          if (hotelFound)
            commit('updateMainInfo', { hotel: hotelFound, main_info });
        });
      });
    }

    return new Promise(async (resolve) => {
      for (const chunk of chunkIds) {
        await getInfo(chunk);
        if (router.currentRoute.path !== '/hotels') {
          resolve();
          return;
        }
      }
      // commit('stopGettingHotelInfoDB', false);
      resolve();
    });
  }
};

const mutations = {
  reset(state) {
    Object.assign(state, initialState);
  },
  sortHotels(state, sort) {
    let callback;
    switch (sort) {
      case 'cheap':
        callback = (a, b) =>
          parseFloat(calcPrice(a.rates[0])) - parseFloat(calcPrice(b.rates[0]));
        break;

      // case 'popular':
      //   callback = (a, b) => b.sort_score - a.sort_score;
      //   break;

      case 'expensive':
        callback = (a, b) =>
          parseFloat(calcPrice(b.rates[0])) - parseFloat(calcPrice(a.rates[0]));
        break;
      case 'center':
        callback = (a, b) =>
          distance(
            state.region.latitude,
            state.region.longitude,
            a.main_info.latitude,
            a.main_info.longitude
          ) -
          distance(
            state.region.latitude,
            state.region.longitude,
            b.main_info.latitude,
            b.main_info.longitude
          );
        break;
      case 'rated':
        callback = (a, b) => b.main_info.rating - a.main_info.rating;
        break;
    }
    state.hotels.sort(callback);
    state.hotelsFiltered.sort(callback);
    setTimeout(() => window.dispatchEvent(new Event('scroll')), 1000);
  },
  filterHotels(state, options) {
    // console.log('init filter');
    state.hotelsFiltered = state.hotels.filter(hotel => {
      const info = hotel.main_info || hotel.info;
      if (!info) {
        return false;
      }
      const hotelname =
        options.hotelName.length > 0
          ? info.name.search(new RegExp(options.hotelName, 'i')) !==
            -1
          : true;
      const stars =
        options.stars.length > 0
          ? options.stars.includes(
              Math.floor(info.star_rating / 10)
            ) ||
            (options.stars.includes(1) && info.star_rating === 0)
          : true;
      
      const min = options.priceStart <= parseFloat(calcPrice(hotel.rates[0]));
      const max = options.priceEnd >= parseFloat(calcPrice(hotel.rates[0]));
      const meal =
        options.meal.length > 0
          ? options.meal.some(
              m => hotel.rates[0].meal.search(new RegExp(m, 'i')) !== -1
            )
          : true;
      return hotelname && stars && min && max && meal;
    });

    if (options.hasOwnProperty('hotelName')) {
      if (options.hotelName.length > 0) state.filters.hotelName = true;
      else state.filters.hotelName = false;
    }

    if (options.hasOwnProperty('stars')) {
      if (options.stars.length > 0) state.filters.stars = true;
      else state.filters.stars = false;
    }

    if (options.hasOwnProperty('meal')) {
      if (options.meal.length > 0) state.filters.meal = true;
      else state.filters.meal = false;
    }

    state.useFilter = Object.values(state.filters).some(f => f);
    setTimeout(() => window.dispatchEvent(new Event('scroll')), 1000);
  },
  updateRelativeHotels(state, result) {
    state.hotels.push(...result.hotels);
  },
  updateHotels(state, result) {
    // state.hotelsClean = [...result.hotels];
    state.hotels = result.hotels.sort(
      (a, b) =>
        parseFloat(calcPrice(a.rates[0])) - parseFloat(calcPrice(b.rates[0]))
    );
    state.hotelsWaitingInfo = [];
    if (state.hotels.length > 1) {
      state.maxPrice = parseInt(calcPrice(state.hotels[state.hotels.length - 1].rates[0]));
    }
    state.hotelsFiltered = state.hotels;
    // Object.assign(state, result);
  },
  updateHotelInfo(state, result) {
    result.forEach(info => {
      const hotel = state.hotels.find(hotel => hotel.id === info.id);
      if (hotel) Vue.set(hotel, 'info', info);
      // console.log(hotel);
    });
  },
  cleanHotelsWaitingInfo(state) {
    state.hotelsWaitingInfo = [];
  },
  updateHotelsWaitingInfo(state, ids) {
    state.hotelsWaitingInfo.push(...ids);
  },
  removeHotelsWaitingInfo(state, ids) {
    // console.log(ids);
    ids.forEach(id =>
      state.hotelsWaitingInfo.splice(state.hotelsWaitingInfo.indexOf(id), 1)
    );
  },
  updateQuery(state, query) {
    state.query = query;
  },
  // setLoading(state, loadingMessage = true) {
  //   state.error = false;
  //   state.loading = true;
  //   state.loadingMessage = loadingMessage;
  // },
  // unsetLoading(state, loadingMessage = true) {
  //   state.error = false;
  //   state.loading = false;
  //   state.loadingMessage = false;
  // },
  throwError(state, reason) {
    state.error = true;
    state.errors.push(reason);
    // eslint-disable-next-line
    console.log(reason, state.errors);
  },
  setCurrentSlide(state, options) {
    const hotel = state.hotels.find(hotel => hotel.id === options.id);
    if (hotel) Vue.set(hotel.info, '_currentSlide', options.slide);
  },
  setPage(state, num) {
    state.page = num;
  },
  updateRegion(state, region) {
    state.region = region;
    // console.log(region);
  },
  updateHotelsRating(state, result) {
    state.hotels.forEach(hotel => {
      const ratingFound = result.find(h => h.hotel_id === hotel.id);
      hotel.main_info.rating = ratingFound ? parseFloat(ratingFound.rating) : 0;
    });
  },
  updateMainInfo(state, { hotel, main_info }) {
    Vue.set(hotel, 'main_info', main_info);
  },
  updateHotelHoveredID(state, id) {
    state.hotelHoveredID = id || '';
  },
  getFavoriteHotels(state) {
    if (localStorage.get('whs'))
      state.favoriteHotels = JSON.parse(localStorage.get('whs'));
  },
  storeFavoriteHotels(state) {
    localStorage.set('whs', JSON.stringify(state.favoriteHotels));
  },
  stopGettingHotelInfoDB(state, stop = true) {
    state.isGettingHotelInfoStopped = stop;
  }
  // updateMap(state) {
  //   const map = L.map('map').setView(
  //     [state.region.latitude, state.region.longitude],
  //     13
  //   );
  //   L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
  //     attribution:
  //       '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  //   }).addTo(map);
  //   state.map = map;
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
